/**
 * Created by wenzi on 2017/6/12.
 */
export const API_ROOT = 'http://219.135.58.197:8888/llhb/m/'



// WEBPACK FOOTER //
// ./src/api/config.js